import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const PlotManagement = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        Plot Management
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Master the art of garden plot organization and management. Learn how to 
          design efficient layouts, optimize space usage, and create a productive 
          garden structure that works for your needs.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Discover how Agritur's plot management features help you visualize your 
          garden layout, track plantings, and maintain organized growing spaces 
          throughout the season.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PlotManagement;
